import React from 'react';
import PropTypes from 'prop-types';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import Button from '../../../../components/UI/Button';
import CheckListItem from '../../../../components/UI/CheckListItem';
import { PlanPrices, SavingsRewards } from '../../../../utils/prices';

interface Props {
  app: AppType;
  plans: PlanPrices;
  savings: SavingsRewards;
  onUpgradeClicked: (plan: Plan) => void;
  analytics: any;
}

const PartnerMaxOnlyPlansContainer = ({
  app,
  plans,
  onUpgradeClicked,
  analytics,
  savings
}: Props) => {
  const { loading } = app;

  return (
    <>
      <h1 data-e2e="upgrade-plans-header">
        Get 3 free<sup>1</sup> months as a WorldStrides traveler
      </h1>
      <h2
        data-testid="upgrade-plans-subheader"
        data-e2e="upgrade-plans-subheader"
      >
        Includes phone and purchase protections plus higher savings and cash
        back
      </h2>
      {plans && plans.max && plans.standard && (
        <div className={css.investOption}>
          <h3 className={css.investOptionHeader}>Greenlight Max</h3>
          <p className={css.maxOnlyPrice}>
            ${plans.max}/month after 3-month trial
          </p>
          <CheckListItem>
            <p>Core tools</p>
            <p
              className={css.checkListItemSubtext}
            >{`Kids’ debit cards & tools for saving, spending, earning, and giving`}</p>
          </CheckListItem>
          <CheckListItem>
            <p>Identity theft, cell phone, and purchase protection**</p>
          </CheckListItem>
          <CheckListItem>
            <p>{'Investing for kids & parents'}</p>
          </CheckListItem>
          <CheckListItem>
            <p>1% Cash Back*</p>
          </CheckListItem>
          <CheckListItem>
            <p>{savings.max} on Savings*</p>
          </CheckListItem>
          <CheckListItem>
            <p>Priority customer support</p>
          </CheckListItem>
          <Button
            text="Start 3 months free"
            loading={loading}
            onClick={() => {
              analytics.trackEvent('Registration Invest Plan Action', {
                eventProps: {
                  plan: Plan.max,
                  price: plans.max,
                  skipped: false
                }
              });
              onUpgradeClicked(Plan.max);
            }}
            data-e2e="upgrade-max"
          />
        </div>
      )}
      <p className={css.investMaxOnly}>
        Switch plans or cancel any time in-app
      </p>
      <div className={css.investFooter}>
        <p>
          <sup>1</sup>Subject to minimum balance requirement and identity
          verification. Offer subject to change at any time.
        </p>
        <p>
          *See Greenlight's Terms of Service for details on earnings limits and
          how to qualify. Subject to change at any time.
        </p>
        <p>
          **Cell phone and purchase protection provided by Virginia Surety
          Company Inc. Cell phone protection is not available to residents of
          New York.
        </p>
        <p>
          Depending on where you live, you may be charged taxes in addition to
          your subscription price.
        </p>
      </div>
    </>
  );
};

export default PartnerMaxOnlyPlansContainer;
